import { useHingeHealthSecurityContext } from '@hinge-health/react-component-library';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SplitWrapper } from '../../../components/split-wrapper';
import { WizardShell } from './components/layout/wizard-shell';
import { WizardStateProvider } from './context/wizard-state.context';
import { ContractStep } from './pages/contract';
import { CspsStep } from './pages/csps';
import { CustomerAccountStep } from './pages/customer-account';
import { DoneStep } from './pages/done';
import { FeeScheduleStep } from './pages/fee-schedule';
import { IntakeStep } from './pages/intake';
import { LocationsStep } from './pages/locations';
import { MerchantStep } from './pages/merchant';
import { PractitionersStep } from './pages/practitioners';
import { ReviewStep } from './pages/review';

export const ContractsWizard = (): JSX.Element => {
  const { hingeHealthAuthState } = useHingeHealthSecurityContext();

  return (
    <SplitWrapper
      treatmentName="HINGE_SELECT_PROVIDER_CONTRACT"
      attributes={{
        uid: hingeHealthAuthState?.accessToken?.claims.uid.toString() || '',
      }}
    >
      <WizardStateProvider>
        <Routes>
          <Route index element={<Navigate to="new/intake" replace />} />
          <Route path="new" element={<WizardShell />}>
            <Route index element={<Navigate to="intake" replace />} />
            <Route path="intake" element={<IntakeStep />} />
            <Route path="merchant" element={<MerchantStep />} />
            <Route path="locations" element={<LocationsStep />} />
            <Route path="practitioners" element={<PractitionersStep />} />
            <Route path="customer-account" element={<CustomerAccountStep />} />
            <Route path="contract" element={<ContractStep />} />
            <Route path="fee-schedule" element={<FeeScheduleStep />} />
            <Route path="csps" element={<CspsStep />} />
            <Route path="review" element={<ReviewStep />} />
            <Route path="done" element={<DoneStep />} />
          </Route>
          <Route path="*" element={<Navigate to="new/intake" replace />} />
        </Routes>
      </WizardStateProvider>
    </SplitWrapper>
  );
};
